import WindowTpl from '../../template/modal/window.html';
import ModalMod from './modal.js';
const MODULE_NAME = 'ui.bootstrap.module.modal';
const ModTpl = $templateCache => {
	$templateCache.put('uib/template/modal/window.html', WindowTpl);
};
ModTpl.$inject = ['$templateCache'];
let compMod = angular.module(MODULE_NAME, [ModalMod]).run(ModTpl);
export default compMod = compMod.name;
